package com.exura.components.dialogs

import com.exura.surface
import com.exura.ui.Dimens
import com.exura.ui.Durations
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.style.ComponentKind
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.addVariant
import com.varabyte.kobweb.silk.theme.colors.palette.overlay
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.div

sealed interface DialogPanelKind : ComponentKind

val DialogOverlayStyle = CssStyle {
    val palette = colorMode.toPalette()
    base {
        Modifier
            .fillMaxSize()
            .position(Position.Fixed)
            .zIndex(100)
            .backgroundColor(palette.overlay.toRgb().copyf(alpha = 0.5f))
            .display(DisplayStyle.Flex)
            .justifyContent(JustifyContent.Center)
            .alignItems(AlignItems.Center)
    }
}

val DialogPanelStyle = CssStyle<DialogPanelKind> {
    val palette = colorMode.toPalette()
    base {
        Modifier
            .backgroundColor(palette.surface)
            .borderRadius(Dimens.dialogBorderRadius)
            .padding(leftRight = Dimens.dialogContentIndent, topBottom = Dimens.dialogContentWrapping)
            .maxWidth(Dimens.dialogMaxCoverWidth)
            .maxHeight(Dimens.dialogMaxCoverHeight)
            .transition(Transition.all(Durations.short))

    }
}

val DialogPanelLargeVariant = DialogPanelStyle.addVariant {
    base {
        Modifier
            .minWidth(Dimens.dialogMaxCoverWidth / 2)
            .minHeight(Dimens.dialogMaxCoverHeight / 2)
    }
}
